import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCheckBold';
/** Renders an SVG icon. */
const SvgCheckBold = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M25.28 8.464a2 2 0 0 1 .256 2.816l-10 12a2 2 0 0 1-2.95.134l-6-6a2 2 0 0 1 2.828-2.828l4.452 4.451L22.464 8.72a2 2 0 0 1 2.816-.256"
      />
    </svg>
  );
};
SvgCheckBold.displayName = displayName;
export default SvgCheckBold;
